import { render, staticRenderFns } from "./OdpReader.vue?vue&type=template&id=17e56cba&scoped=true&"
import script from "./OdpReader.vue?vue&type=script&lang=ts&"
export * from "./OdpReader.vue?vue&type=script&lang=ts&"
import style0 from "./OdpReader.vue?vue&type=style&index=0&id=17e56cba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e56cba",
  null
  
)

export default component.exports